import { useState } from 'react';

import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { filteredAllergens } from '../../app/commonSelector';
import { setUser, userSelector } from '../../app/main/mainSlice';
import { useAppDispatch, useAppSelector } from '../../app/store/hooks';
import useUserPreference from '../../utils/globalSettings/usePreferenceQuery';
import useHomePageJson from '../newHomePage/utils/useHomePageJson';
import styles from "./userPreference.module.css";

const AllergenSelector = ({ setDrawer }: { setDrawer: React.Dispatch<React.SetStateAction<boolean>> }) => {
  const dispatch = useAppDispatch();
  const allergens = useAppSelector(filteredAllergens);
  const user = useAppSelector(userSelector);
  const [checked, setChecked] = useState<string[]>(user?.userSettings?.allergens || []);
  const { fetchHomePage, loading: fetchingJson } = useHomePageJson(true);

  const { updatingUserSettings, loading: settingAllergens } = useUserPreference();

  const handleAllergensClicked = (value: string) => {
    let newChecked = [...checked];

    if (newChecked.includes(value)) newChecked = newChecked.filter((item) => item !== value);
    else newChecked.push(value);

    setChecked(newChecked);
  };

  const clearFilter = () => setChecked([]);

  const handleSelectUserSettings = async (settings: { diet?: string; allergens?: string[] | undefined; }) => {
    if (user?.id) {
      await updatingUserSettings(user?.id, settings, () => {
        dispatch(setUser({ user: { ...user, userSettings: settings } }));
      });
    }

    await fetchHomePage(null, checked);

    setDrawer(false);
  };

  const applyAllergens = () => {
    const userSettings = { ...user?.userSettings, allergens: checked };
    handleSelectUserSettings(userSettings);
  }

  return (
    <Grid className={styles.allergenSelectorContainer}>
      <Grid className={styles.allergensRadioGroups}>
        {allergens.map((value) => (
          <FormControl className={styles.allergen} disabled={settingAllergens || fetchingJson} key={value}
            onClick={!(settingAllergens || fetchingJson) ? () => handleAllergensClicked(value) : undefined}>
            <Checkbox
              checked={checked.includes(value)}
              className={styles.allergenCheckBox}
              disabled={settingAllergens || fetchingJson}
              inputProps={{ 'aria-label': 'controlled' }}
            />
            <Typography variant="caption3Light">{value}</Typography>
          </FormControl>
        ))}
      </Grid>
      <Grid className={styles.clearAndApplyContainer}>
        <Grid className={styles.clearAllAllergens} onClick={() => clearFilter()}>
          <Typography variant='body5'>Clear All</Typography>
        </Grid>
        <Grid className={styles.applyAllergens} onClick={() => applyAllergens()}>
          {settingAllergens || fetchingJson ? <CircularProgress color='inherit' disableShrink size={20}
            variant='indeterminate' /> : <Typography variant='body5'>Apply</Typography>}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default AllergenSelector